<template>
    <div class="add-order-comment-form">
        <BForm>
            <BTextarea 
                v-model="salesOrderComment"
                :readonly="isSaving['salesOrderComment'] || !hasPermission('orders.addcomment')"
                placeholder="Voeg een notitie toe..."
                spellcheck="false"
                size="xl"
                style="min-height: 187px;"
                class="mb-1"
            />
        </BForm>

        <OmniButtonCollection class="mt-4" alignment="end">
            <OmniButton
                @click="cancelEditComment"
                :disabled="cancelButtonDisabled"
                icon="times"
                size="lg"
                variant="danger"
            >
                {{ $t('omt.gui.general.action.cancel') }}
            </OmniButton>

            <OmniButton
                @click="saveComment"
                :disabled="saveButtonDisabled"
                :isProcessing="isSaving['salesOrderComment']"
                icon="save"
                size="lg"
                variant="success"
            >
                {{ $t('omt.gui.general.action.save') }}
            </OmniButton>
        </OmniButtonCollection>
    </div>
</template>

<script>
export default {
    name: 'OrderCommentsForm',

    data() {
        return {
            isSaving: {
                salesOrderComment: false,
            },
            salesOrderComment: '',
        }
    },

    props: {
        salesOrderIdentifier: {
            type: String,
            required: true,
            default: ''
        },
        editComment: {
            type: Object | null,
            default: null,
        },
    },

    mounted() {
        this.salesOrderComment = this.editComment?.comment ?? ''
    },

    methods: {
        cancelEditComment() {
            if (!confirm('Weet je zeker dat je de gemaakte wijzigingen wilt weggooien?')) {
                return
            }

            this.salesOrderComment = '';
            this.$emit('close');
        },

        saveComment() {
            this.isSaving['salesOrderComment'] = true;

            const promise = (!this.editComment)
                ? this.$http.post(`/api/rest/sales-orders/${this.salesOrderIdentifier}/comments`, {
                    comment: this.salesOrderComment,
                })
                : this.$http.put(`/api/rest/sales-orders/${this.salesOrderIdentifier}/comments/${this.editComment.id}`, {
                    comment: this.salesOrderComment,
                })

            promise
                .then(response => {
                    this.$alert('Opmerking opgeslagen')
                    this.$emit('saved');
                })
                .catch(e => {
                    console.error(e)
                    this.$alert('Fout bij het opslaan van de opmerking', 'danger')
                })
                .then(() => {
                    this.isSaving['salesOrderComment'] = false
                })
        },
    },

    computed: {
        isNoteFieldFilled() {
            return !!this.salesOrderComment.trim().length > 0;
        },

        isFormValid() {
            return this.isNoteFieldFilled;
        },

        isSavingSomething() {
            return Object.keys(this.isSaving).some(key => this.isSaving[key] === true);
        },

        saveButtonDisabled() {
            return !this.isFormValid && !this.isSavingSomething && !this.hasPermission('orders.addcomment');
        },

        cancelButtonDisabled() {
            return this.isSavingSomething;
        },
    }
}
</script>
